export enum ExportResultsTag {
  DateFrom = 'DateFrom',
  DateTo = 'DateTo',
  FileName = 'FileName',
  ServiceType = 'ServiceType',
  SizeMore = 'SizeMore',
  SizeLess = 'SizeLess',
  UserName = 'UserName'
}

export const ExportResultsTagsMap = new Map<ExportResultsTag, { tag: string; prop: string }>([
  [ExportResultsTag.UserName, { tag: 'User name', prop: 'UserName' }],
  [ExportResultsTag.FileName, { tag: 'File name', prop: 'Name' }],
  [ExportResultsTag.ServiceType, { tag: 'Service type', prop: 'ServiceType' }],
  [ExportResultsTag.DateFrom, { tag: 'Date from', prop: 'CreateDate' }],
  [ExportResultsTag.DateTo, { tag: 'To date', prop: 'CreateDate' }],
  [ExportResultsTag.SizeMore, { tag: 'Size more than', prop: 'Size' }],
  [ExportResultsTag.SizeLess, { tag: 'Size less than', prop: 'Size' }]
]);
